import {Injectable} from '@angular/core';
import {jwtDecode} from 'jwt-decode';
import {FGRAuthTokenModel} from "../models/fgrauth-token.model";
import {MedicoPrimaryKey} from "../models/medico.model";

@Injectable({
  providedIn: 'root'
})
export class AuthTokenService {

  constructor() {
  }

  public get token(): string | null {
    return localStorage.getItem('token');
  }

  public set token(value: string | null) {
    if (value == null) {
      localStorage.removeItem('token');
    } else {
      localStorage.setItem('token', value ?? '');
    }
  }

  private get decodedToken(): FGRAuthTokenModel | null {
    let token = localStorage.getItem('token');
    return token == null ? null : jwtDecode<FGRAuthTokenModel>(token);
  }

  public get isExpired(): boolean {
    let exp = this.decodedToken?.exp;
    return exp == undefined ? true : Date.now() >= exp * 1000;
  }

  public get userId(): string | null {
    let sub = this.decodedToken?.sub;
    return sub == undefined ? null : sub;
  }

  public get profile(): string | null {
    return this.decodedToken?.PROFILE ?? null;
  }

  public get medicoId(): MedicoPrimaryKey | undefined {
    let tipoConselho = this.decodedToken?.tipoConselho != undefined ? parseInt(this.decodedToken?.tipoConselho!) : undefined
    let siglaUF = this.decodedToken?.siglaUf;
    let numConselho = this.decodedToken?.numConselho;

    return tipoConselho == undefined ? undefined : {
      tipo_Conselho: tipoConselho,
      sigla_UF: siglaUF,
      num_Conselho: numConselho
    } as MedicoPrimaryKey;
  }

  public get userName(): string | null {
    return this.decodedToken?.name ?? null;
  }

  public clearAll(): void {
    localStorage.clear();
  }
}
